module.exports = __webpack_public_path__ + "static/media/banner.41d4aa9f.svg";